import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = "plans/payments";

export class PaymentsService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listStatus(params?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/status/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listMethods(params?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/methods/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async listUserPayments(params?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/user/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}